import { render, staticRenderFns } from "./MarginYCustoms.vue?vue&type=template&id=08eb66ff"
import script from "./MarginYCustoms.vue?vue&type=script&lang=js"
export * from "./MarginYCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports